import React, { useRef, useState } from "react";
import Select from "react-select";

import { CustomDropdownWithChevron } from "../../../components";
import { customSelectStyles } from "../../../shared/Constants";

interface HandDropdownProps {
  domHands: string[];
  handFilter: string;
  onHandFilterChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const DOM_HAND_LABELS: Record<string, string> = {
  RHA: "Right Hand",
  LHA: "Left Hand",
  SHA: "Switch Hand",
};

export const HandDropdown = React.memo<HandDropdownProps>(
  ({ domHands, handFilter, onHandFilterChange }) => {
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const containerRef = useRef<HTMLDivElement>(null);

    const allOptions = [
      { value: "all", label: "All Hands" },
      ...domHands.map((hand) => ({
        value: hand,
        label: DOM_HAND_LABELS[hand] || hand,
      })),
    ];

    const handleMenuClose = () => {
      setTimeout(() => {
        if (
          containerRef.current &&
          !containerRef.current.contains(document.activeElement)
        ) {
          setMenuIsOpen(false);
        }
      }, 0);
    };

    return (
      <div className="mb-4" data-testid="hand-dropdown" ref={containerRef}>
        <label htmlFor="hand-select" className="sr-only">
          Filter by hand
        </label>
        <Select
          inputId="hand-select"
          value={{
            value: handFilter,
            label:
              handFilter === "all"
                ? "Select Hand"
                : DOM_HAND_LABELS[handFilter] || handFilter,
          }}
          onChange={(option) => {
            if (option && option.value) {
              onHandFilterChange({
                target: { value: option.value },
              } as React.ChangeEvent<HTMLSelectElement>);
              setMenuIsOpen(false);
            }
          }}
          options={allOptions}
          onMenuOpen={() => setMenuIsOpen(true)}
          onMenuClose={handleMenuClose}
          menuIsOpen={menuIsOpen}
          className="text-sm"
          classNamePrefix="hand"
          isSearchable={false}
          components={{
            DropdownIndicator: CustomDropdownWithChevron,
            IndicatorSeparator: () => null,
          }}
          styles={{
            ...customSelectStyles,
            option: (base, state) => ({
              ...base,
              backgroundColor: state.isFocused ? "#F3F4F6" : "white",
              color: "#374151",
              cursor: "pointer",
              padding: "8px 12px",
            }),
          }}
          aria-label="Filter movements by hand"
        />
      </div>
    );
  },
);

HandDropdown.displayName = "HandDropdown";
